import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Tom de um indicador. Conjunto fechado: cada valor é também o sufixo da classe de estilo
 * (`kpi--info`), então acrescentar um tom aqui pede a regra correspondente no SCSS.
 */
export enum ETomKpi {
    INFO = 'info',
    SUCESSO = 'sucesso',
    ATENCAO = 'atencao'
}

/**
 * Cartão de indicador das telas de Comissões: selo de ícone à esquerda, e à direita o número em
 * destaque, o nome do que ele mede e uma legenda que diz o que aquele número significa.
 *
 * <p>É puramente de apresentação — não busca dado nem formata regra de negócio. Quem o usa entrega
 * texto pronto, para que a mesma peça sirva a contagens, datas e traços de "sem valor".
 */
@Component({
    selector: 'app-kpi-comissoes',
    standalone: true,
    templateUrl: './kpi-comissoes.html',
    styleUrls: ['./kpi-comissoes.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiComissoesComponent {
    /** Classe do ícone (PrimeIcons), ex.: `pi pi-calendar-clock`. */
    readonly icone = input.required<string>();
    /** Número, data ou traço de ausência. Vem formatado de quem usa. */
    readonly valor = input.required<string>();
    /** O que o número mede — é ele que dá sentido ao ícone, que é decorativo. */
    readonly rotulo = input.required<string>();
    /** Linha de apoio: o que o número significa. Vazia, a linha não é renderizada. */
    readonly legenda = input('');
    /** Tom do selo e do número. */
    readonly tom = input<ETomKpi>(ETomKpi.INFO);

    /** Classe do tom, derivada para o template não montar string. */
    protected readonly classeDoTom = computed(() => `kpi--${this.tom()}`);
}

/** Traço de ausência dos indicadores: meia-risca, não hífen — é dado que falta, não subtração. */
export const SEM_DADO_KPI = '–';
